import gr from './locales/gr.json';
import en from './locales/en.json';

export const resources = {
  en: {
    translation: en,
  },
  gr: {
    translation: gr,
  },
};
